module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createFromTrainingModule":"Create from existing module"},"fr":{"createFromTrainingModule":"Créer à partir d\u0027un module existant"}}')
  delete Component.options._Ctor
}
